import { Link } from 'react-router-dom';
import { User } from 'lucide-react';
import { useAuth } from '@/features/auth/AuthProvider';
import { SafeImage } from '@/shared/ui';
import type { AssistenteLink } from './assistenteService';
import { AcoesBalaoMia } from './AcoesBalaoMia';
import { BlocosMia } from './BlocosMia';
import { caminhoInterno } from './lerBlocosMia';
import { AnexosMia } from './AnexosMia';
import { PropostaMia } from './PropostaMia';
import { TextoAssistente } from './TextoAssistente';
import type { ItemMia } from './useConversaMia';
import mia from './mia.png';
import styles from './AssistenteWidget.module.css';

function linkJaNoTexto(texto: string, link: AssistenteLink): boolean {
  return texto.includes(`[${link.rotulo}](${link.path})`);
}

export function AvatarMia() {
  return <img className={styles.avatar} src={mia} alt="" />;
}

function AvatarUsuario() {
  const { user } = useAuth();
  return (
    <span className={styles.avatar} aria-hidden>
      {user?.fotoUrl ? <SafeImage src={user.fotoUrl} alt="" variant="avatar" /> : <User size={16} />}
    </span>
  );
}

type Props = {
  item: ItemMia;
  /** Sugestoes e botoes "perguntar" so valem na ultima fala da Mia. */
  ultimaDaMia: boolean;
  ocupado: boolean;
  onPerguntar: (texto: string) => void;
  onAvaliar: (nota: -1 | 0 | 1, motivo?: string) => Promise<void>;
  onRegenerar?: () => void;
  onConfirmar: (campos?: Record<string, string>) => Promise<boolean | void>;
  onCancelar: () => Promise<void>;
  onFecharDiaAberto?: () => Promise<void>;
};

export function ItemFioMia({
  item,
  ultimaDaMia,
  ocupado,
  onPerguntar,
  onAvaliar,
  onRegenerar,
  onConfirmar,
  onCancelar,
  onFecharDiaAberto,
}: Props) {
  const daMia = item.papel === 'assistente';
  const blocos = ultimaDaMia ? item.blocos : item.blocos.filter((bloco) => bloco.tipo !== 'sugestoes');
  return (
    <div className={`${styles.linha} ${daMia ? styles.linhaAssistente : styles.linhaUsuario}`}>
      {daMia ? <img className={`${styles.avatar} ${styles.avatarSobreBarra}`} src={mia} alt="" /> : null}
      <div className={daMia ? `${styles.colunaMia} mia-balao` : undefined}>
        <div className={daMia ? styles.balaoAssistente : styles.balaoUsuario}>
          {daMia ? <TextoAssistente texto={item.texto} /> : <p className={styles.fala}>{item.texto}</p>}
          {daMia ? null : <AnexosMia anexos={item.anexos ?? []} />}
          {item.links
            ?.filter((link) => caminhoInterno(link.path) && !linkJaNoTexto(item.texto, link))
            .map((link) => (
              <div key={link.path} className={styles.links}>
                <Link className={styles.link} to={link.path}>
                  {link.rotulo}
                </Link>
              </div>
            ))}
          {daMia && item.proposta && item.propostaEstado ? (
            <PropostaMia
              proposta={item.proposta}
              estado={item.propostaEstado}
              resultado={item.resultado}
              diaAberto={item.diaAberto}
              onFecharDiaAberto={onFecharDiaAberto}
              onConfirmar={onConfirmar}
              onCancelar={onCancelar}
            />
          ) : null}
          {daMia ? <BlocosMia blocos={blocos} onPerguntar={onPerguntar} desabilitado={ocupado} /> : null}
        </div>
        {daMia ? (
          <AcoesBalaoMia
            texto={item.texto}
            idMensagem={item.idMensagem}
            nota={item.nota}
            onAvaliar={onAvaliar}
            onRegenerar={onRegenerar}
          />
        ) : null}
      </div>
      {daMia ? null : <AvatarUsuario />}
    </div>
  );
}
